import React from 'react'
import CircularProgress from '@mui/material/CircularProgress'

const SharedCircularProgress = (props) => (
  <CircularProgress thickness={5} variant="indeterminate" {...props} />
)

export default SharedCircularProgress
